import { Injectable } from '@angular/core';
import { HttpService } from '@utils/http.service';

@Injectable({
  providedIn: 'root'
})
export class RfcService {
  constructor(
    private http: HttpService
  ) { }

  public create = async (body: any) => await this.http.post(`/api/v1/rfc`, body)
    .then((response: any) => response.data)

  public list = async () => await this.http.get(`/api/v1/rfc`)
    .then((response: any) => response.data)

  public updateRequest = async (body: any) => await this.http.put(`/api/v1/rfc/updaterequest`, body)
    .then((response: any) => response.data)

  public massiveUpload = async (body: any) => await this.http.post(`/api/v1/rfc/massive`, body)
    .then((response: any) => response.data)
}
